import { createContext } from 'react';

import { FormInstance } from 'antd';

import { Combo } from '../../../../../../../shared/interfaces';
import { PaymentMethodDataForServices, PaymentMethodFormValuesInput, PaymentMethodsAdded, StepThreePaymentMethodForm } from '../../interfaces';
import { UploadPreliquidationDocumentsServiceRequestParams } from '../../../../shared/interfaces';
import { PaymentListValues } from '../../../../shared/interfaces/services/get-payments-list-service.interface';
import { DocumentUploadServiceRequestParams } from '../../../../../../../shared/interfaces/services/post-send-claim-documents-service';
import { AxiosResponse } from 'axios';

interface StepThreeFormContextProps {

    stepThreePaymentMethodForm:             FormInstance<StepThreePaymentMethodForm> | undefined;

    paymentMethodFormValues:                PaymentMethodFormValuesInput | undefined;    
    setPaymentMethodFormValues:             React.Dispatch<React.SetStateAction<PaymentMethodFormValuesInput | undefined>>

    paymentMethodsDataTable:                Array<PaymentMethodsAdded>;
    setPaymentMethodsDataTable:             React.Dispatch<React.SetStateAction<PaymentMethodsAdded[]>>;
    
    getPaymentMethodsOptions:               () => Promise<void>;
    getBanksOptions:                        () => Promise<void>;
    getAllBanksOptions:                     () => Promise<Combo[] | undefined>;
    
    paymentMethods:                         Combo[] | undefined;
    banksOptions:                           Combo[] | undefined;
    allBanksOptions:                        Combo[] | undefined;
    

    postPaymentMethod:                      (codePaymentMethod: number, params: PaymentMethodDataForServices) => Promise<AxiosResponse<any>>;
    deletePaymentMethod:                    (codePaymentMethod: number, params: PaymentMethodDataForServices) => Promise<void>;
    proccessPayments:                       () => Promise<boolean>;
    postSavePreliquidation:                 () => Promise<void>;
    postSendPreliquidation:                 () => Promise<AxiosResponse<any>>;
    postUploadDocumentation:                (params: DocumentUploadServiceRequestParams) => Promise<number>;

    paymentMethodSequence:                  number;
    setPaymentMethodSequence:               React.Dispatch<React.SetStateAction<number>>;
    depositBankNumber:                      number;
    setDepositBankNumber:                   React.Dispatch<React.SetStateAction<number>>; 
    depositIntegratedCollectionNumber:      number;
    setDepositIntegratedCollectionNumber:   React.Dispatch<React.SetStateAction<number>>;

    calculatedTotals:                       { totalAmountPaid: number; totalRemainder: number;}

    getPaymentList:                         (currentPayments?: any) => Promise<void>;
    
    paymentsList:                           Array<PaymentListValues>;
    setPaymentsList:                        React.Dispatch<React.SetStateAction<PaymentListValues[]>>;

    paymentsToLoad:                           Array<any>;
    setPaymentsToLoad:                        React.Dispatch<React.SetStateAction<any[]>>;
   
    filesToSend:                           Array<DocumentUploadServiceRequestParams>;
    setFilesToSend:                        React.Dispatch<React.SetStateAction<DocumentUploadServiceRequestParams[]>>;

    hasChanges: boolean;
    setHasChanges: React.Dispatch<React.SetStateAction<boolean>>;

    getBankLabel: (codigoBanco: number, paymentMethod: number) => string | undefined;
}

export const StepThreeFormContext = createContext({} as StepThreeFormContextProps);